export const es = {
    title: `Reenviar correo de confirmación`,
    description: `Tu cuenta no está confirmada.`,
    lastSentAt: `Último correo de confirmación enviado el {date}`,
    wait: `Por favor espera {minutes} minutos antes de reenviar.`,
    resendButton: `Reenviar correo`,
    emailResent: `El correo de confirmación ha sido reenviado`,
    success: `Correo de confirmación enviado.`,
    failure: `No se pudo reenviar el correo de confirmación.`,
    progress: `Reenviando el correo de confirmación...`,
};
//# sourceMappingURL=es.js.map